import { Location } from '@components/Hotels/types';

import LOCATION_TYPE from '@constants/locationTypes';

const getDefaultLocation = (
  type: string,
  url: string,
  name: string,
  id: number,
  parentId: number | null,
): Location => {
  switch (type) {
    case LOCATION_TYPE.STATE:
      return {
        id,
        name,
        type: LOCATION_TYPE.STATE,
        detailed_type: LOCATION_TYPE.STATE,
        url,
        parent_id: parentId,
        parent_type: null,
        indexName: '',
        objectID: '',
        queryID: '',
        state_code: '',
        country_code: '',
        city_name: '',
      };
    case LOCATION_TYPE.COUNTRY:
      return {
        id,
        name,
        type: LOCATION_TYPE.COUNTRY,
        detailed_type: LOCATION_TYPE.COUNTRY,
        url,
        parent_id: parentId,
        parent_type: null,
        indexName: '',
        objectID: '',
        queryID: '',
        state_code: '',
        country_code: '',
        city_name: '',
      };
    case LOCATION_TYPE.CITY_HIGHLIGHTED:
      return {
        id,
        name,
        type: LOCATION_TYPE.CITY,
        detailed_type: LOCATION_TYPE.CITY_HIGHLIGHTED,
        url,
        parent_id: parentId,
        parent_type: null,
        indexName: '',
        objectID: '',
        queryID: '',
        state_code: '',
        country_code: '',
        city_name: '',
      };
    case LOCATION_TYPE.CITY:
      return {
        id,
        name,
        type: LOCATION_TYPE.CITY,
        detailed_type: LOCATION_TYPE.CITY,
        url,
        parent_id: parentId,
        parent_type: null,
        indexName: '',
        objectID: '',
        queryID: '',
        state_code: '',
        country_code: '',
        city_name: '',
      };
    default:
      return {
        id: 1,
        name: '',
        type: LOCATION_TYPE.STATE,
        detailed_type: LOCATION_TYPE.STATE,
        url,
        parent_id: null,
        parent_type: null,
        indexName: '',
        objectID: '',
        queryID: '',
        state_code: '',
        country_code: '',
        city_name: '',
      };
  }
};

export default getDefaultLocation;
